import { Box, Card, CardContent, Skeleton, Stack } from "@mui/material";

function TaskCardSkeleton() {
  return (
    <Card
      sx={{
        borderRadius: "16px",
        border: "none",
        boxShadow: "0 0 6px #7faee052",
        bgcolor: "#ffffff",
      }}
    >
      <CardContent sx={{ p: { xs: 1.5, md: 2 } }}>
        <Skeleton variant="text" width="45%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="35%" height={16} sx={{ mb: 1.5 }} />
        <Skeleton variant="text" width="70%" height={14} />
        <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
          <Skeleton variant="rounded" width={64} height={22} sx={{ borderRadius: 2 }} />
          <Skeleton variant="rounded" width={72} height={22} sx={{ borderRadius: 2 }} />
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function TaskListSectionSkeleton() {
  return (
    <Box>
      <Stack spacing={2}>
        {Array.from({ length: 4 }).map((_, i) => (
          <TaskCardSkeleton key={i} />
        ))}
      </Stack>
    </Box>
  );
}
